import { AutocompleteWebsiteItem } from "@similarweb/ui-components";

import type { Recent } from "app/custom-hooks/useRecentsHook";
import { createWebsiteUrlFromRecent } from "app/pages/activation/components/HomeSearch/helpers/createWebsiteUrlFromRecent";
import { getWebsiteDomains } from "app/pages/activation/components/HomeSearch/helpers/getWebsiteDomains";
import { redirectToUrl } from "app/pages/activation/components/HomeSearch/helpers/redirectToUrl";
import type { OnSearchItemClick } from "app/pages/activation/components/HomeSearch/types";
import { defaultWebsiteState } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketingHelper";

export const createRecentWebsiteItem = (
    item: Recent,
    onClick?: OnSearchItemClick,
    pageName = defaultWebsiteState,
    additionalParams = {},
) => {
    const url = createWebsiteUrlFromRecent(item, pageName, additionalParams);
    const { mainSite, compareSites } = getWebsiteDomains(item);

    const onItemClick = () => {
        onClick?.(mainSite.domain, "recent");

        redirectToUrl(url);
    };

    return (
        <AutocompleteWebsiteItem
            mainSite={mainSite}
            compareSites={compareSites}
            onItemClick={onItemClick}
        />
    );
};
